import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import * as Sentry from '@sentry/angular';
import { environmentAdmin } from '@lexplus-environments';
import { redactSentryEvent } from '@lexplus-shared-lib';
/// <reference types="@angular/localize" />

// Sentry/Bugsink Reporting
Sentry.init({
  dsn: environmentAdmin.sentryDsn.app,
  environment: environmentAdmin.name,
  enabled: environmentAdmin.name !== 'localhost',
  initialScope: {},
  beforeSend: redactSentryEvent,
});

bootstrapApplication(App, appConfig).catch((err) => console.error(err));
